let theme: any;

const getCurrentTheme = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

const changeAttribute = (newTheme: any) => {
  const currentThemeArrary = ["dark-background"];
  currentThemeArrary.forEach((item) => {
    window.document.documentElement.setAttribute(item, newTheme);
  });
};

const autoChangeTheme = () => {
  if (theme !== "auto") return;
  let systemTheme = getCurrentTheme();
  changeAttribute(systemTheme);
};

let hasListener = false;
const setListener = () => {
  if (hasListener) return;
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", autoChangeTheme);
  hasListener = true;
};

export function changeTheme(getTheme: any) {
  if (theme === getTheme) return;
  theme = getTheme;
  if (getTheme === "auto") {
    setListener();
    getTheme = getCurrentTheme();
  }
  changeAttribute(getTheme);
}

// 获取当前的主题 'dark' or 'light'
export function getTheme() {
  return (
    window.document.querySelector("html")?.getAttribute("dark-background") ||
    getCurrentTheme()
  );
}
